// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Ban as RawBan } from "lucide-react";
export const Ban = /* @__PURE__ */ createIcon(RawBan, "Ban", 2);
